import React from 'react';

import Link from 'next/link';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import useWindowSize from '@components/common/hooks/useWindowSize';
import Text from '@components/common/Text/Text';
import { M_DEVICE } from '@components/lpc/Constants';
import { potCreationTypeEnum } from '@models/PotModel/createPotCategoryModel';
import { ROUTE } from '@services/http/Route';

import css from './PoolCreation.module.scss';
import Pools from './Pools/Pools';

const PoolCreation = () => {
    const { width } = useWindowSize();
    const { t } = useTranslateLpc('lpc-solidarity-page');
    return (
        <div className={css.pool_creation_container}>
            <div className={css.pool_creation_container__content}>
                <div className={css.pool_creation_container__content__left_side}>
                    <div className={css.shadow_inset_white}>
                        <Pools />
                    </div>
                </div>
                <div className={css.pool_creation_container__content__right_side}>
                    <div className={css.pool_creation_container__content__right_side__content}>
                        <div>
                            <Text
                                variant={'body_02'}
                                color={'black-gray'}
                                customClass={css.pool_creation_container__content__right_side__content__title}
                            >
                                {t('pool_creation.title_one')}
                            </Text>
                            <Text
                                variant={'body_02'}
                                color={'black-gray'}
                                customClass={css.pool_creation_container__content__right_side__content__title}
                            >
                                {t('pool_creation.title_two')}
                            </Text>
                        </div>
                        {width > M_DEVICE ? (
                            <div>
                                <Text
                                    variant={'body_02'}
                                    color={'light-black-gray-tint-1'}
                                    customClass={css.pool_creation_container__content__right_side__content__desc}
                                >
                                    {t('pool_creation.description_one')}
                                </Text>
                                <Text
                                    variant={'body_02'}
                                    color={'light-black-gray-tint-1'}
                                    customClass={css.pool_creation_container__content__right_side__content__desc}
                                >
                                    {t('pool_creation.description_two')}
                                </Text>
                                <Text
                                    variant={'body_02'}
                                    color={'light-black-gray-tint-1'}
                                    customClass={css.pool_creation_container__content__right_side__content__desc}
                                >
                                    {t('pool_creation.description_three')}
                                </Text>
                            </div>
                        ) : (
                            <Text
                                variant={'body_02'}
                                color={'light-black-gray-tint-1'}
                                customClass={css.pool_creation_container__content__right_side__content__desc}
                            >
                                {`${t('pool_creation.description_one')} ${t('pool_creation.description_two')} ${t('pool_creation.description_three')}`}
                            </Text>
                        )}
                        <Link
                            href={{
                                pathname: ROUTE.LPC.POT.CREATE_POT,
                                query: {
                                    category: potCreationTypeEnum.LPS,
                                    utm_source: potCreationTypeEnum.LPS,
                                },
                            }}
                        >
                            <Button
                                customClass={css.pool_creation_container__content__right_side__content__cta}
                                variant={'primary'}
                            >
                                {t(`pool_creation.create`)}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PoolCreation;
